import * as React from 'react';
import { History } from 'history';

import { match } from 'react-router';
import { slide as Menu } from 'react-burger-menu'
import { IResponseCount, initialResponseCount } from 'src/share/types/case/searchCase';
import { CasesService } from 'src/share/services/cases';
import CaseSidebarLinks from './CaseSidebarLinks';
import { ICase } from 'src/share/types/case/case';
import './mobileCaseSidebar.css'
import Sidebar from 'src/modules/Routing/Sidebar/Siderbar';

export interface ICaseSidebarProps {
    match: match<{ caseId?: string }>
    caseData?: ICase;
    loading?: boolean;
    isMobile: boolean;
    pageWrapId?: string;
    history: History;
}

export interface ICaseSidebarState {
    count: IResponseCount;
    isOpen: boolean;
    isCasesView: boolean | null
}

export class CaseSidebar extends React.Component<ICaseSidebarProps, ICaseSidebarState> {
    constructor(props: ICaseSidebarProps) {
        super(props);
        this.state = {
            count: initialResponseCount,
            isOpen: false,
            isCasesView: null
        }
    }
    public componentDidMount() {
        if (this.isCasesView()) {
            this.getCount()
        } else {
            this.setState({ isCasesView: false });
        }
    }
    public async getCount() {
        const count = await CasesService.getCount();
        this.setState({ count })
    }
    public isCasesView() {
        const { pathname } = this.props.history.location;
        const isCasesView = pathname.startsWith('/cases');
        this.setState({ isCasesView });
        return isCasesView;
    }
    public hideMobileSidebar = () => {
        this.setState({ isOpen: false })
    }
    public onMobileChange = (sidebar) => {
        this.setState({ ...sidebar })
    }
    public render() {
        const { match: { params, url }, caseData, loading } = this.props;
        const { caseId } = params;
        const { count, isCasesView } = this.state;
        return (
            this.props.isMobile ?
                <Menu burgerButtonClassName={"fa fa-chevron-circle-right"} crossButtonClassName={"fa fa-times"}
                    className={"mobileCaseSidebar"} onStateChange={this.onMobileChange} pageWrapId={this.props.pageWrapId} isOpen={this.state.isOpen} width={'50%'} noOverlay={true} onClick={() => null}>
                    <CaseSidebarLinks
                        caseId={caseId}
                        count={count}
                        loading={loading}
                        isCasesView={isCasesView}
                        caseData={caseData}
                        hideMobileSidebar={this.hideMobileSidebar}
                        url={url}
                    />
                </Menu> :
                <Sidebar className="sidebar">
                    <CaseSidebarLinks
                        caseId={caseId}
                        count={count}
                        loading={loading}
                        isCasesView={isCasesView}
                        caseData={caseData}
                        hideMobileSidebar={this.hideMobileSidebar}
                        url={url}
                    />
                </Sidebar>
        );
    }
}

export default CaseSidebar;
